// extracted by mini-css-extract-plugin
export default {"indicator":"nZM_HvkctvQhl8kUDeZf"};